import { render, staticRenderFns } from "./subProgram.vue?vue&type=template&id=19614802&scoped=true"
import script from "./subProgram.vue?vue&type=script&lang=js"
export * from "./subProgram.vue?vue&type=script&lang=js"
import style0 from "./subProgram.vue?vue&type=style&index=0&id=19614802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19614802",
  null
  
)

export default component.exports